function addToCart(variantID) {
  console.log(variantID);
        jQuery.ajax({
            type: "post",
            url: "/cart/add.json",
            data: {
                id: variantID,
                quantity: 1
            },
            dataType: "jsonp",
            success: function (a) {
              console.log(a);
               jQuery.ajax({
                        url: '/cart.js',
                        dataType: "json",
                        cache: false,
                        success: function(cart) {
                            Theme.cart.refreshMiniCart(cart);
//                           show_cart();
                        }
                    });
            },
            error: function (a) {
//                 alert("There was some error adding the item to cart!")
                show_cart();
            }
        })
}